var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _rect3, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranslation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    height: 60,
    rx: 10,
    width: 60
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f1f3f4",
    height: 30,
    rx: 4,
    width: 24,
    x: 8,
    y: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28,39.5H12A5.506,5.506,0,0,1,6.5,34V12A5.506,5.506,0,0,1,12,6.5H28A5.506,5.506,0,0,1,33.5,12V34A5.506,5.506,0,0,1,28,39.5ZM12,9.5A2.5,2.5,0,0,0,9.5,12V34A2.5,2.5,0,0,0,12,36.5H28A2.5,2.5,0,0,0,30.5,34V12A2.5,2.5,0,0,0,28,9.5Z",
    fill: "#aaadbf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26,33.5a1.482,1.482,0,0,1-.77-.214C24.79,33.023,14.5,26.749,14.5,18a1.5,1.5,0,0,1,3,0c0,7.045,9.18,12.658,9.273,12.715A1.5,1.5,0,0,1,26,33.5Z",
    fill: "#aaadbf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26,21H14a3,3,0,0,1,0-6H26a3,3,0,0,1,0,6Z",
    fill: "#f1f3f4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28,19.5H12a1.5,1.5,0,0,1,0-3H28a1.5,1.5,0,0,1,0,3Z",
    fill: "#aaadbf"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20,19.5A1.5,1.5,0,0,1,18.5,18V14a1.5,1.5,0,0,1,3,0v4A1.5,1.5,0,0,1,20,19.5Z",
    fill: "#aaadbf"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14,33.5a1.5,1.5,0,0,1-.775-2.785C13.32,30.658,22.5,25.045,22.5,18a1.5,1.5,0,0,1,3,0c0,8.749-10.29,15.023-10.728,15.286A1.494,1.494,0,0,1,14,33.5Z",
    fill: "#aaadbf"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#bec6f4",
    height: 30,
    rx: 4,
    width: 24,
    x: 28,
    y: 22
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48,53.5H32A5.506,5.506,0,0,1,26.5,48V26A5.506,5.506,0,0,1,32,20.5H48A5.506,5.506,0,0,1,53.5,26V48A5.506,5.506,0,0,1,48,53.5Zm-16-30A2.5,2.5,0,0,0,29.5,26V48A2.5,2.5,0,0,0,32,50.5H48A2.5,2.5,0,0,0,50.5,48V26A2.5,2.5,0,0,0,48,23.5Z",
    fill: "#8d9cf4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28,49.5A1.5,1.5,0,0,1,26.5,48V26A5.506,5.506,0,0,1,32,20.5H48a1.5,1.5,0,0,1,0,3H32A2.5,2.5,0,0,0,29.5,26V48A1.5,1.5,0,0,1,28,49.5Z",
    fill: "#7bcdd1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46,45.5a1.5,1.5,0,0,1-1.379-.909L40,33.808,35.379,44.591a1.5,1.5,0,0,1-2.758-1.182l6-14a1.5,1.5,0,0,1,2.758,0l6,14A1.5,1.5,0,0,1,46,45.5Z",
    fill: "#f1f3f4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44,41.5H36a1.5,1.5,0,0,1,0-3h8a1.5,1.5,0,0,1,0,3Z",
    fill: "#f1f3f4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslation);
export default __webpack_public_path__ + "static/media/translation.23fdebc604318cdc0715810b84c534b7.svg";
export { ForwardRef as ReactComponent };